import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=c4ac1f14&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./OrderDialog.vue?vue&type=script&lang=ts"
export * from "./OrderDialog.vue?vue&type=script&lang=ts"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=c4ac1f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ac1f14",
  null
  
)

export default component.exports